var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentcreationIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-471.000000, -6320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21",
    transform: "translate(471.000000, 6320.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#935AFE",
    x: 0,
    y: 0,
    width: 22.0649595,
    height: 28.0055256,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1243935,7.98543763 C16.6766783,7.98543763 17.1243935,8.43315288 17.1243935,8.98543763 C17.1243935,9.49827346 16.7383533,9.92094479 16.2410146,9.97870989 L16.1243935,9.98543763 L6.32345408,9.98543763 C5.77116933,9.98543763 5.32345408,9.53772238 5.32345408,8.98543763 C5.32345408,8.47260179 5.70949427,8.04993046 6.20683295,7.99216536 L6.32345408,7.98543763 L16.1243935,7.98543763 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1243935,14.3503298 C16.6766783,14.3503298 17.1243935,14.7980451 17.1243935,15.3503298 C17.1243935,15.8631656 16.7383533,16.285837 16.2410146,16.3436021 L16.1243935,16.3503298 L6.32345408,16.3503298 C5.77116933,16.3503298 5.32345408,15.9026146 5.32345408,15.3503298 C5.32345408,14.837494 5.70949427,14.4148226 6.20683295,14.3570575 L6.32345408,14.3503298 L16.1243935,14.3503298 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2239238,20.715222 C11.7762085,20.715222 12.2239238,21.1629372 12.2239238,21.715222 C12.2239238,22.2280578 11.8378836,22.6507291 11.3405449,22.7084942 L11.2239238,22.715222 L6.32345408,22.715222 C5.77116933,22.715222 5.32345408,22.2675067 5.32345408,21.715222 C5.32345408,21.2023861 5.70949427,20.7797148 6.20683295,20.7219497 L6.32345408,20.715222 L11.2239238,20.715222 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8248471,23.2715866 L19.4052997,23.2715866 C19.9575845,23.2715866 20.4052997,23.7193019 20.4052997,24.2715866 C20.4052997,24.4764743 20.3423648,24.6764175 20.2250094,24.8443659 L18.9027261,26.7366978 C18.5863888,27.189411 17.9629503,27.2999655 17.5102372,26.9836283 C17.407709,26.9119858 17.3195313,26.8217446 17.2502792,26.717587 L15.9921098,24.825255 C15.6863272,24.365347 15.8112706,23.744632 16.2711786,23.4388494 C16.4352302,23.3297752 16.6278443,23.2715866 16.8248471,23.2715866 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E966FF",
    transform: "translate(18.141556, 25.605380) rotate(31.000000) translate(-18.141556, -25.605380) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2163073,8.4865229 L24.308221,8.4865229 C25.4127905,8.4865229 26.308221,9.3819534 26.308221,10.4865229 L26.308221,21.7622641 C26.308221,22.8668336 25.4127905,23.7622641 24.308221,23.7622641 L23.2163073,23.7622641 C22.1117378,23.7622641 21.2163073,22.8668336 21.2163073,21.7622641 L21.2163073,10.4865229 C21.2163073,9.3819534 22.1117378,8.4865229 23.2163073,8.4865229 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E966FF",
    transform: "translate(23.762264, 16.124394) rotate(31.000000) translate(-23.762264, -16.124394) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5068277,5.97072465 L30.5987415,5.97072465 C31.1510262,5.97072465 31.5987415,6.4184399 31.5987415,6.97072465 L31.5987415,7.94100766 C31.5987415,8.49329241 31.1510262,8.94100766 30.5987415,8.94100766 L27.5068277,8.94100766 C26.954543,8.94100766 26.5068277,8.49329241 26.5068277,7.94100766 L26.5068277,6.97072465 C26.5068277,6.4184399 26.954543,5.97072465 27.5068277,5.97072465 Z",
    id: "\\u77E9\\u5F62",
    fill: "#FF76FB",
    transform: "translate(29.052785, 7.455866) rotate(31.000000) translate(-29.052785, -7.455866) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentcreationIconBig);
export default __webpack_public_path__ + "static/media/Intelligentcreation_icon_big.83c35e9cd0212c83f784cc2a08222983.svg";
export { ForwardRef as ReactComponent };